import script from "./ReservaServiciosSeleccion.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservaServiciosSeleccion.vue?vue&type=script&setup=true&lang=js"

import "./ReservaServiciosSeleccion.vue?vue&type=style&index=0&id=0e52c003&lang=scss&scoped=true"
import "./ReservaServiciosSeleccion.vue?vue&type=style&index=1&id=0e52c003&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e52c003"]])

export default __exports__